import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import PainPoints from "@/components/landing/PainPoints";
import Method from "@/components/landing/Method";
import Chapters from "@/components/landing/Chapters";
import Author from "@/components/landing/Author";
import Testimonials from "@/components/landing/Testimonials";
import Offer from "@/components/landing/Offer";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";
import AdminBanners from "@/components/AdminBanners";

function LandingPage() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div data-testid="landing-page" className="grain min-h-screen bg-cream font-sans text-ink antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <PainPoints />
        <Method />
        <Chapters />
        <Author />
        <Testimonials />
        <Offer />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin-banners" element={<AdminBanners />} />
      </Routes>
    </BrowserRouter>
  );
}
